import { render, staticRenderFns } from "./TournamentPage.vue?vue&type=template&id=730bf503&scoped=true&"
import script from "./TournamentPage.vue?vue&type=script&lang=js&"
export * from "./TournamentPage.vue?vue&type=script&lang=js&"
import style0 from "./TournamentPage.vue?vue&type=style&index=0&id=730bf503&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730bf503",
  null
  
)

export default component.exports